<svelte:options accessors/>
<script lang="ts">
import NauiInput from "../../../naui/atoms/NauiInput.svelte";

export let item;
export let label;

</script>

<tr>
    <td>
        <div>Cupos {label}</div>
    </td>
    <td>
        <div>
            <NauiInput type="number" bind:value={item.cupos} label=""/>
        </div>
    </td>
</tr>
<tr>
    <td>
        <div>Valor cupo {label}</div>
    </td>
    <td>
        <div>
            <NauiInput type="currency" id={label + '-cupo'} bind:value={item.valor} label=""/>
        </div>
    </td>
</tr>